import { render, staticRenderFns } from "./com-page.vue?vue&type=template&id=0f7ee713&scoped=true&"
import script from "./com-page.vue?vue&type=script&lang=js&"
export * from "./com-page.vue?vue&type=script&lang=js&"
import style0 from "./com-page.vue?vue&type=style&index=0&id=0f7ee713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ee713",
  null
  
)

export default component.exports